"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[928],{

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchBoards; }
/* harmony export */ });
/* unused harmony export ViewSetBoard */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchBoards = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.rows
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBoards(body) {
        return _ref.apply(this, arguments);
    };
}();
var ViewSetBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewSetBoard(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 85134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ smallPackagingFileAPI; },
/* harmony export */   "t": function() { return /* binding */ smallPackagingAPI; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var smallPackagingAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SMALLPACKAGING */ .Z.SMALLPACKAGING).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function smallPackagingAPI(body) {
        return _ref.apply(this, arguments);
    };
}();
var smallPackagingFileAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].SMALLPACKAGING */ .Z.SMALLPACKAGING).postFiles(body);
                case 2:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function smallPackagingFileAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 62645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export CustomFileInputWrapper */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _alert__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55150);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  .nonHover {\n    overflow: auto;\n    border-width: 2px;\n    border-style: dashed;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    min-height: 100px;\n    border-color: ",
        ";\n  }\n\n  .nonHover .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border-bottom: 1px solid #6c757d;\n    padding: 10px;\n  }\n\n  .fileList {\n    overflow: auto;\n    padding: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    & .fileName {\n      cursor: pointer;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      transition: none;\n    }\n    & .fileName:hover {\n      color: #3bb77e;\n    }\n\n    & .fileSize {\n      margin-left: 6px;\n      color: rgb(100 116 139);\n    }\n  }\n\n  .fileList:hover {\n    background-color: rgb(203, 213, 225, 0.3);\n  }\n\n  .noFiles {\n    border-style: dashed;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .deleteBtn {\n    cursor: pointer;\n  }\n  .deleteBtn:hover {\n    color: #dc3545;\n  }\n\n  .fileInputHover {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    min-height: 100px;\n    border-style: dashed;\n    border-width: 3px;\n    border-radius: 10px;\n    border-color: #3bb77e;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #3bb77e;\n    cursor: pointer;\n    background-color: #fff;\n  }\n\n  .fileInputLabel {\n    height: 100%;\n    min-height: 100px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    margin: 0;\n  }\n\n  .fileInputLabel:hover {\n    color: #3bb77e;\n    background-color: #fff;\n    margin: 0;\n  }\n\n  .fileImg {\n    max-width: 24px;\n    font-size: 24px;\n    font-weight: 300;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var CustomFileInputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e8abcfa3-0"
})(_templateObject(), function(props) {
    return props.$error ? "#dc3545" : "#6c757d";
});
var CustomFileInput = function(props) {
    // 각 항목 클릭시 임시 다운로드
    // handleFiles 로 끌어올림
    var handleFiles = props.handleFiles, max = props.max, ment = props.ment, reset = props.reset, error = props.error;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), files = ref1[0], setFiles = ref1[1];
    var hoverRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var nonHoverRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleDrop = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
        var droppedFiles = Array.from(e.dataTransfer.files);
        var tempArr = _toConsumableArray(files).concat(_toConsumableArray(droppedFiles));
        if (max && tempArr.length > max) {
            (0,_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uD30C\uC77C\uC740 \uCD5C\uB300 ".concat(max, "\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
            setFiles(tempArr.slice(0, max));
            return;
        }
        setFiles(tempArr);
    };
    var handleDragOver = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "visible";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "hidden";
    };
    var handleDragLeave = function(e) {
        e.preventDefault();
        if (hoverRef.current) hoverRef.current.style.visibility = "hidden";
        if (nonHoverRef.current) nonHoverRef.current.style.visibility = "visible";
    };
    var onChangeFiles = function(e) {
        var fileList = e.target.files ? Array.from(e.target.files) : [];
        var tempArr = _toConsumableArray(files).concat(_toConsumableArray(fileList));
        if (max && tempArr.length > max) {
            (0,_alert__WEBPACK_IMPORTED_MODULE_2__/* .failAlert */ .qh)("\uD30C\uC77C\uC740 \uCD5C\uB300 ".concat(max, "\uAC1C\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4."));
            setFiles(tempArr.slice(0, max));
            e.target.value = "";
            return;
        }
        setFiles(tempArr);
        e.target.value = "";
    };
    var deleteFile = function(i) {
        var tempArr = _toConsumableArray(files);
        tempArr.splice(i, 1);
        setFiles(tempArr);
    };
    var fileTypeCheck = function(name) {
        var ref;
        var key = (ref = name.split(".").pop()) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        switch(key){
            case "txt":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/txt.png"
                });
            case "doc":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/doc.png"
                });
            case "docx":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/docx.png"
                });
            case "jpg":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/jpg.png"
                });
            case "jpeg":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/jpeg.png"
                });
            case "png":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/png.png"
                });
            case "gif":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/gif.png"
                });
            case "mp3":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mp3.png"
                });
            case "wav":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/wav.png"
                });
            case "wmv":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/wmv.png"
                });
            case "flac":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/flac.png"
                });
            case "mp4":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mp4.png"
                });
            case "avi":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/avi.png"
                });
            case "mkv":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/mkv.png"
                });
            case "pdf":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/pdf.png"
                });
            case "zip":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/zip.png"
                });
            case "xls":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/xls.png"
                });
            case "ppt":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/ppt.png"
                });
            case "pptx":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/ppt.png"
                });
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "/img/fileIcons/file.png"
                });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (handleFiles) {
            handleFiles(files);
        }
        if (reset) {
            reset(files);
        }
    }, [
        files
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(CustomFileInputWrapper, {
            className: "d-flex flex-colum w-100 position-relative",
            $error: error,
            children: [
                files && files.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: "nonHover",
                    className: "nonHover",
                    onDragOver: handleDragOver,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "me-3",
                                            children: [
                                                "\uCCA8\uBD80\uD30C\uC77C ",
                                                files.length,
                                                "\uAC1C"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "",
                                            children: [
                                                (files.reduce(function(acc, cur) {
                                                    return acc + cur.size;
                                                }, 0) / 1024).toFixed(2),
                                                "KB"
                                            ]
                                        })
                                    ]
                                }),
                                (!max || files.length < max) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                    role: "button",
                                    className: "d-flex align-items-center text-primary",
                                    htmlFor: "fileInput",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-file-import me-1"
                                        }),
                                        "\uD30C\uC77C \uCD94\uAC00"
                                    ]
                                })
                            ]
                        }),
                        files.map(function(file, i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "fileList",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "d-flex align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "me-2 fileImg",
                                                children: fileTypeCheck(file.name)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fileName",
                                                onClick: function() {
                                                    var url = URL.createObjectURL(file);
                                                    var a = document.createElement("a");
                                                    a.href = url;
                                                    a.target = "_blank";
                                                    a.click();
                                                },
                                                children: file.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "fileSize",
                                                children: "(" + (file.size / 1024).toFixed(2) + "KB)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex items-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "deleteBtn",
                                            onClick: function() {
                                                return deleteFile(i);
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                className: "fi-rs-cross w-6 h-6"
                                            })
                                        })
                                    })
                                ]
                            }, i);
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "nonHover",
                    className: "nonHover noFiles",
                    style: {
                        visibility: "visible"
                    },
                    onDragOver: handleDragOver,
                    onDrop: handleDrop,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                            id: "fileInputLabel",
                            htmlFor: "fileInput",
                            className: "fileInputLabel",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "d-flex align-items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fi-rs-file-import me-2"
                                        }),
                                        ment ? ment : "\uD30C\uC77C\uC744 \uB4DC\uB798\uADF8 \uD558\uAC70\uB098 \uD074\uB9AD\uD558\uC138\uC694."
                                    ]
                                }),
                                max && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    className: "ms-2",
                                    children: [
                                        "(\uCD5C\uB300 ",
                                        max,
                                        "\uAC1C)"
                                    ]
                                })
                            ]
                        })
                    })
                }),
                (!max || files.length < max) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    id: "hover",
                    className: "fileInputHover",
                    style: {
                        visibility: "hidden"
                    },
                    onDragLeave: handleDragLeave,
                    onDrop: handleDrop,
                    onDragOver: handleDragOver,
                    ref: hoverRef,
                    children: "\uD30C\uC77C \uCD94\uAC00"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "file",
                    multiple: !max || max > 1,
                    id: "fileInput",
                    className: "visually-hidden",
                    onChange: onChangeFiles
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomFileInput);


/***/ }),

/***/ 74547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60007);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: fixed;\n  top: 0;\n  left: 0;\n  background-color: ",
        ";\n  z-index: 100000008;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .modal-section {\n    min-width: 40%;\n    background-color: white;\n    border-radius: 20px;\n    overflow: hidden;\n    @media (max-width: 991px) {\n      width: 60%;\n      overflow: auto;\n    }\n    @media (max-width: 767px) {\n      width: 90%;\n      overflow: auto;\n    }\n  }\n\n  .modal-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var PostCodeModal = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44e38a55-0"
})(_templateObject(), function(props) {
    return props.isCheckout ? "" : "rgba(0, 0, 0, 0.8)";
});
var PostCode = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PostCodeModal, {
            onClick: props === null || props === void 0 ? void 0 : props.onClickHandleModal,
            isCheckout: props.isCheckout,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "modal-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "modal-content",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_daum_postcode__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        style: {
                            height: "470px"
                        },
                        onComplete: props === null || props === void 0 ? void 0 : props.onCompletePostCode
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PostCode);


/***/ }),

/***/ 89126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ evidenceCheck; },
/* harmony export */   "v": function() { return /* binding */ autoPhoneFormat; }
/* harmony export */ });
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var autoPhoneFormat = function(phoneNumber) {
    if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(0, 2)) == "02") {
        var value = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/-/g, "").replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
        return value;
    } else {
        var value1 = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.replace(/-/g, "").replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        return value1;
    }
};
var evidenceCheck = function(insertNum) {
    var regsplitNum = insertNum.replace(/-/gi, "").split("").map(function(item) {
        return parseInt(item, 10);
    });
    if (regsplitNum.length === 10) {
        var regkey = [
            1,
            3,
            7,
            1,
            3,
            7,
            1,
            3,
            5
        ];
        var regNumSum = 0;
        for(var i = 0; i < regkey.length; i++){
            regNumSum += regkey[i] * regsplitNum[i];
        }
        regNumSum += parseInt(regkey[8] * regsplitNum[8] / 10, 10);
        var regCheck = Math.floor(regsplitNum[9]) === (10 - regNumSum % 10) % 10;
        return regCheck;
    }
};


/***/ }),

/***/ 52658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ PrintDesignService; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32252);


var PrintDesignService = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .DesignBanner */ .fF, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "content container-lg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "textContent",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: "\uB85C\uACE0\uAC00 \uC5C6\uB2E4\uBA74?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                            children: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                "\uAC04\uB2E8\uD55C \uB85C\uACE0 \uBC30\uCE58\uBD80\uD130 \uBE0C\uB79C\uB4DC \uB514\uC790\uC778\uAE4C\uC9C0! ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                " \uAC00\uACA9\uBCC4\uB85C \uB098\uC5D0\uAC8C \uB9DE\uB294 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD574\uBCF4\uC138\uC694"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "https://file.caretbio.com/caretbio/9ac7d2c8185a56a72ecf459b2021022a.png",
                            className: "m_banner"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: "",
                            href: "/customizing/design-service/",
                            children: "\uC11C\uBE44\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://file.caretbio.com/caretbio/47ffdb3584f54f4251b1c79b3aad90c1.png",
                    className: "pc_banner"
                })
            ]
        })
    });
};


/***/ }),

/***/ 34077:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ printCart_PrintCart; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./components/customizing/print/printCart/PrintCart.styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 50px;\n  margin-bottom: 50px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & h2 {\n    margin-bottom: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: 30px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-column-gap: 10px;\n  grid-row-gap: 10px;\n  margin-bottom: 20px;\n  @media screen and (max-width: 767px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-height: 30rem;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  padding: 20px;\n  position: relative;\n  background-color: white;\n  display: flex;\n  flex-direction: column;\n  color: black;\n\n  :last-of-type {\n    margin-right: 0;\n  }\n\n  .title {\n    margin-bottom: 20px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #ececec;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: flex;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  margin-bottom: 1rem;\n  align-items: center;\n\n  @media (max-width: 460px) {\n    flex-wrap: wrap;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        ";\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px;\n  :last-of-type {\n    margin-bottom: 0;\n  }\n\n  .form-control {\n    width: 70%;\n    display: flex;\n    height: 30px;\n    padding: 0px 20px;\n    text-align: center;\n    margin-right: 10px;\n    margin-bottom: 10px;\n    :last-of-type {\n      margin-right: 0px;\n    }\n  }\n\n  .env-policy {\n    display: flex;\n    align-items: center;\n\n    & label {\n      margin-right: 5px;\n      cursor: pointer;\n    }\n    .policy {\n      cursor: pointer;\n    }\n  }\n\n  .custome-checkbox {\n    margin: 0 !important;\n    & label {\n      ::before {\n        margin-bottom: 3px;\n      }\n    }\n  }\n\n  & textarea {\n    min-height: 120px;\n  }\n\n  .btn-md {\n    padding: 5px 10px !important;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        " !important;\n  min-width: 70px !important;\n  font-size: 1rem;\n  word-break: keep-all;\n  display: flex;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  min-width: 200px !important;\n  font-size: 1rem;\n  word-break: keep-all;\n  margin-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-right: 10px;\n  .example {\n    background-color: #3bb77e;\n    padding: 5px;\n    color: #fff;\n    font-size: 0.8rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid #ececec;\n  height: 40px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding-left: 20px;\n  font-size: 16px;\n  width: ",
        ";\n  width: ",
        ";\n  margin-right: 1rem;\n\n  :last-child {\n    margin: 0;\n  }\n\n  :focus {\n    background: transparent;\n    border-color: #bce3c9;\n  }\n  @media (max-width: 1199px) {\n    width: 100%;\n  }\n  @media (max-width: 460px) {\n    width: 70%;\n    :nth-of-type(2) {\n      width: 75%;\n      margin-left: 0;\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n  min-width: 80px !important;\n  height: 40px;\n  padding-left: 10px;\n  border-radius: 10px;\n  border: 1px solid #ececec;\n  margin-right: 1rem;\n  color: #253d4e;\n\n  @media (max-width: 460px) {\n    width: 70%;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  width: 50%;\n  height: 40px;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 0;\n  color: #fff;\n  word-break: keep-all;\n  border: 1px solid transparent;\n  background-color: ",
        ";\n  cursor: pointer;\n  border-radius: 10px;\n  :hover {\n    background: #fdc040 !important;\n  }\n  @media (max-width: 1199px) {\n    width: 50%;\n  }\n  @media (max-width: 460px) {\n    font-size: 12px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  margin-bottom: 1rem;\n  align-items: center;\n  & div {\n    width: 50%;\n  }\n  & input {\n    height: 40px;\n    width: calc(50% - 16px);\n    min-width: 65px;\n    margin-left: 16px;\n    text-align: center;\n    padding: 0;\n  }\n  @media (max-width: 1199px) {\n    & div {\n      width: 100%;\n    }\n    & input {\n      width: calc(50% - 16px);\n    }\n  }\n\n  @media (max-width: 460px) {\n    & div {\n      width: 70%;\n    }\n    & input {\n      width: calc(50% - 16px);\n    }\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  & input {\n    display: none;\n  }\n\n  & ul {\n    width: 70%;\n  }\n  & li {\n    width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    word-break: break-all;\n    margin: 0;\n  }\n\n  .delete_file_btn {\n    color: red;\n    cursor: pointer;\n    :hover {\n      color: orange;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  width: 30%;\n  padding: 10px;\n  cursor: pointer;\n  border: 1px dashed #ececec;\n  text-align: center;\n  margin-right: 10px;\n  @media screen and (max-width: 1200px) {\n    width: 50%;\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  & span {\n    text-align: end;\n    margin-bottom: 10px;\n  }\n\n  & table {\n    text-align: center;\n    @media screen and (max-width: 767px) {\n      display: none;\n    }\n  }\n\n  .info {\n    > div {\n      display: flex;\n      align-items: center;\n      word-break: keep-all;\n    }\n    & img {\n      max-width: 50px;\n    }\n  }\n  & td {\n    word-break: keep-all;\n  }\n\n  .btn-primary {\n    :hover {\n      border-color: #fdc040;\n    }\n  }\n\n  .btn-danger {\n    background-color: #dc3545;\n    :hover {\n      border-color: #fd7e14;\n      background-color: #fd7e14;\n    }\n  }\n\n  .custome-checkbox .form-check-label::before {\n    margin: 0;\n  }\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  display: flex;\n  justify-content: end;\n\n  & button {\n    margin-right: 10px;\n    :last-of-type {\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  @media (max-width: 767px) {\n    display: flex;\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  @media (max-width: 767px) {\n    width: 100%;\n    display: flex;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n    padding-bottom: 1rem;\n    border-bottom: 1px solid #ececec;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n  width: 20%;\n  margin-right: 5%;\n  & img {\n    width: 100%;\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  width: 75%;\n  display: none;\n  flex-direction: column;\n  align-items: flex-start;\n  cursor: pointer;\n  @media screen and (max-width: 767px) {\n    display: flex;\n  }\n\n  & h6 {\n    width: 100%;\n    font-weight: 500;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: pre-wrap;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    margin-bottom: 10px;\n    font-size: 20px;\n    :hover {\n      color: #3bb77e;\n    }\n  }\n  & span {\n    margin-bottom: 10px;\n    font-size: 16px;\n  }\n  & div {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    word-break: keep-all;\n    & span {\n      width: 100%;\n      display: flex;\n      text-align: start;\n    }\n  }\n\n  .btn_wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: end;\n    margin-left: auto;\n  }\n\n  @media (max-width: 575px) {\n    & h6 {\n      font-size: 18px;\n    }\n    & span {\n      font-size: 16px;\n    }\n    & div {\n      & h6 {\n        font-size: 16px;\n      }\n    }\n  }\n  @media (max-width: 424px) {\n    & h6 {\n      font-size: 16px;\n    }\n    & span {\n      font-size: 14px;\n    }\n  }\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px solid #3bb77e;\n  background-color: #3bb77e;\n  border-radius: 100%;\n  width: 36px;\n  height: 36px;\n  font-size: 18px;\n  margin: auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #fff;\n  padding: 5px;\n  cursor: pointer;\n  :hover {\n    opacity: 0.8;\n  }\n  & i {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-876c4427-0"
})(_templateObject());
var CartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-1"
})(_templateObject1());
var InfoWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-2"
})(_templateObject2());
var InfoBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-3"
})(_templateObject3());
var FormInputRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-4"
})(_templateObject4(), function(props) {
    return props.half ? "50%" : "100%";
});
var FormInputLargeRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-5"
})(_templateObject5(), function(props) {
    return props.half ? "50%" : "100%";
});
// span
var FormInputBasicSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-876c4427-6"
})(_templateObject6(), function(props) {
    return props.large ? "30%" : "15%";
});
// 100% span
var FormInputLargeSpan = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-876c4427-7"
})(_templateObject7());
// input
var FormInputBasicInput = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-876c4427-8"
})(_templateObject8(), function(props) {
    return props.address ? "50%" : "50%";
}, function(props) {
    return props.full && "100%";
});
// select
var FormInputBasicSelect = styled_components_browser_esm/* default.select.withConfig */.ZP.select.withConfig({
    componentId: "sc-876c4427-9"
})(_templateObject9());
var FormBasicBtn = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-876c4427-10"
})(_templateObject10(), function(props) {
    return props.isCheckingTime ? "#ececec" : "#3bb77e";
});
// 주소 검색
var AddressSearch = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-11"
})(_templateObject11());
var FileUploadWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-12"
})(_templateObject12());
var FileUploadLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-13"
})(_templateObject13());
var CartTableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-14"
})(_templateObject14());
var CartBtnWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-15"
})(_templateObject15());
var MobileCartWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-16"
})(_templateObject16());
// 모바일 상품
var CartProductsMobile = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-17"
})(_templateObject17());
var ProductMobileImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-18"
})(_templateObject18());
var ProductMobileInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-19"
})(_templateObject19());
// 모바일 상품 끝
var PlusIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-876c4427-20"
})(_templateObject20());

// EXTERNAL MODULE: ./redux/action/confirm.js
var action_confirm = __webpack_require__(94184);
// EXTERNAL MODULE: ./redux/action/loading.js
var loading = __webpack_require__(19828);
// EXTERNAL MODULE: ./common/splicePrice.js
var splicePrice = __webpack_require__(8025);
// EXTERNAL MODULE: ./common/postcode.js
var postcode = __webpack_require__(74547);
// EXTERNAL MODULE: ./components/map/Maptainer.js
var Maptainer = __webpack_require__(590);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./common/CustomFileInput.js
var CustomFileInput = __webpack_require__(62645);
// EXTERNAL MODULE: ./api/smallPackaging.js
var smallPackaging = __webpack_require__(85134);
// EXTERNAL MODULE: ./common/util/checkout-validation.js
var checkout_validation = __webpack_require__(89126);
// EXTERNAL MODULE: ./redux/action/defaultModal.js
var defaultModal = __webpack_require__(84439);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js
var QueryClientProvider = __webpack_require__(30202);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
;// CONCATENATED MODULE: ./components/customizing/print/printCart/PrintCart.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



















var PrintCart = function(param) {
    var _$openConfirmModal = param.openConfirmModal, _$modifyConfirmModal = param.modifyConfirmModal, _$closeConfirmModal = param.closeConfirmModal, _$isLoaded = param.isLoaded, _$isLoading = param.isLoading, userInfo = param.userInfo, userCompany = param.userCompany, moveToList = param.moveToList, _$closeDefaultModal = param.closeDefaultModal, _$modifyDefaultModal = param.modifyDefaultModal, _$openDefaultModal = param.openDefaultModal;
    var ref15, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var queryClient = (0,QueryClientProvider/* useQueryClient */.NL)();
    var ref3 = (0,react.useState)(false), isOpen = ref3[0], setIsOpen = ref3[1];
    var ref4 = (0,react.useState)(""), pickAddress = ref4[0], setPickAddress = ref4[1];
    var ref5 = (0,react.useState)({}), userInputs = ref5[0], setUserInputs = ref5[1];
    var ref6 = (0,react.useState)([]), infoFiles = ref6[0], setInfoFiles = ref6[1];
    // 선택 견적
    var ref7 = (0,react.useState)([]), selectedItem = ref7[0], setSelectedItem = ref7[1];
    var ref8 = (0,react.useState)([]), confirmItems = ref8[0], setConfirmItems = ref8[1];
    var ref9 = (0,react.useState)([]), printCartItems = ref9[0], setPrintCartItems = ref9[1];
    (0,react.useEffect)(function() {
        var cart = queryClient.getQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ]) || [];
        setPrintCartItems(cart);
    }, []);
    // 수량 변경
    var handleCnt = function(e, pcode) {
        var currentCart = queryClient.getQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ]) || [];
        var updatedCart = currentCart.map(function(el) {
            if (el.pcode === pcode) {
                var newCnt = Math.min(Number(e.target.value) || 1, 1000);
                return _objectSpread({}, el, {
                    cnt: newCnt > 0 ? newCnt : 1
                });
            }
            return el;
        });
        sessionStorage.setItem("printCart", JSON.stringify(updatedCart));
        queryClient.setQueryData([
            queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
        ], updatedCart);
        setPrintCartItems(updatedCart);
    };
    // 장바구니 삭제
    var deleteBasketItem = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee1(pcode) {
            var content;
            return runtime_default().wrap(function _callee$(_ctx1) {
                while(1)switch(_ctx1.prev = _ctx1.next){
                    case 0:
                        content = {
                            title: "\uC0AD\uC81C\uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?",
                            actionBtnLabel: "\uD655\uC778",
                            actionBtnValid: true,
                            cancelBtnLabel: "\uCDE8\uC18C",
                            onAction: _asyncToGenerator(runtime_default().mark(function _callee() {
                                var currentCart, newCart;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            currentCart = queryClient.getQueryData([
                                                queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
                                            ]) || [];
                                            newCart = currentCart.filter(function(el) {
                                                return el.pcode !== pcode;
                                            });
                                            sessionStorage.setItem("printCart", JSON.stringify(newCart));
                                            queryClient.setQueryData([
                                                queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
                                            ], newCart);
                                            setPrintCartItems(newCart);
                                            (0,common_alert/* successAlert */.Cq)("\uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                            _$closeConfirmModal();
                                        case 7:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        };
                        _$modifyConfirmModal(content);
                        _$openConfirmModal();
                    case 3:
                    case "end":
                        return _ctx1.stop();
                }
            }, _callee1);
        }));
        return function deleteBasketItem(pcode) {
            return _ref.apply(this, arguments);
        };
    }();
    // 입력 값 적용
    var onChangeUserInputs = function(id) {
        return function(e) {
            if (id === "phone" || id === "receipt_num") {
                setUserInputs(_objectSpread({}, userInputs, _defineProperty({}, id, e.target.value)));
                e.target.value = (0,checkout_validation/* autoPhoneFormat */.v)(e.target.value);
                return;
            }
            setUserInputs(_objectSpread({}, userInputs, _defineProperty({}, id, e.target.value)));
        };
    };
    var onChangeFiles = function(files) {
        setInfoFiles(_toConsumableArray(files));
    };
    // 우편번호 검색
    var onClickHandleModal = function() {
        setIsOpen(function(prev) {
            return !prev;
        });
    };
    var onCompletePostCode = function(postcode) {
        setPickAddress(postcode.address);
        setUserInputs(_objectSpread({}, userInputs, {
            addressLoad: postcode.roadAddress !== "" ? postcode.roadAddress : postcode.autoRoadAddress,
            addressJibun: postcode.jibunAddress !== "" ? postcode.jibunAddress : postcode.autoJibunAddress,
            addressCode: postcode.zonecode
        }));
        setIsOpen(false);
    };
    // 견적 선택
    var selectItem = function(i, el) {
        return function(e) {
            var tempArr = _toConsumableArray(selectedItem);
            tempArr[i] = e.target.checked;
            setSelectedItem(tempArr);
            if (e.target.checked) {
                var tempArr2 = _toConsumableArray(confirmItems);
                tempArr2[i] = el;
                setConfirmItems(tempArr2);
            } else {
                var tempArr21 = _toConsumableArray(confirmItems);
                tempArr21[i] = undefined;
                setConfirmItems(tempArr21);
            }
        };
    };
    // 견적 요청
    var confirmCustomizing = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee2() {
            var ref16, ref10, ref11, ref12, ref13, ref14, body;
            return runtime_default().wrap(function _callee$(_ctx2) {
                while(1)switch(_ctx2.prev = _ctx2.next){
                    case 0:
                        ;
                        if (!(printCartItems.filter(function(el) {
                            return el !== undefined;
                        }).length < 1)) {
                            _ctx2.next = 3;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC120\uD0DD\uD55C \uACAC\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."));
                    case 3:
                        if (!(printCartItems.length === 0 || printCartItems == undefined)) {
                            _ctx2.next = 5;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uC694\uCCAD\uD560 \uACAC\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."));
                    case 5:
                        body = {
                            modes: "InsertSet",
                            usages: userInputs.productInfo ? userInputs.productInfo : "",
                            company: userInputs.company || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.name),
                            name: userInputs.name || (userInfo === null || userInfo === void 0 ? void 0 : (ref16 = userInfo.Member) === null || ref16 === void 0 ? void 0 : ref16.name),
                            tel: userInputs.phone || (userInfo === null || userInfo === void 0 ? void 0 : (ref10 = userInfo.Member) === null || ref10 === void 0 ? void 0 : ref10.phone),
                            email: userInputs.email || (userInfo === null || userInfo === void 0 ? void 0 : (ref11 = userInfo.Member) === null || ref11 === void 0 ? void 0 : ref11.email),
                            zipcode: userInputs.addressCode || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.zipcode),
                            doro_addr: userInputs.addressLoad || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.doro_addr),
                            base_addr: userInputs.addressJibun || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.base_addr),
                            detail_addr: userInputs.detail_addr || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.detail_addr),
                            mapx: ((ref12 = userInputs.addressGps) === null || ref12 === void 0 ? void 0 : ref12.mapx) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.mapx),
                            mapy: ((ref13 = userInputs.addressGps) === null || ref13 === void 0 ? void 0 : ref13.mapy) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.mapy),
                            content: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.content) ? userInputs.content : "",
                            files: infoFiles,
                            items: JSON.stringify(printCartItems.filter(function(el) {
                                return el !== undefined;
                            })),
                            editYn: userInputs.editYn || "TYPE0",
                            message: (userInputs.message || (userInfo === null || userInfo === void 0 ? void 0 : (ref14 = userInfo.Member) === null || ref14 === void 0 ? void 0 : ref14.message) || "").trim()
                        };
                        if (!(body.company === "" || body.company === undefined || body.name === "" || body.name === undefined || body.tel === "" || body.tel === undefined || body.email === "" || body.email === undefined)) {
                            _ctx2.next = 8;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uB2F4\uB2F9\uC790 \uC815\uBCF4\uB97C \uC785\uB825\uD558\uC138\uC694."));
                    case 8:
                        if (!(body.zipcode === "" || body.zipcode === undefined || body.doro_addr === "" || body.doro_addr === undefined || body.detail_addr === "" || body.detail_addr === undefined)) {
                            _ctx2.next = 10;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uBC30\uC1A1\uC9C0 \uC815\uBCF4\uB97C \uC785\uB825\uD558\uC138\uC694."));
                    case 10:
                        if (!(body.editYn !== "TYPE2" && body.files.length < 1)) {
                            _ctx2.next = 12;
                            break;
                        }
                        return _ctx2.abrupt("return", (0,common_alert/* failAlert */.qh)("\uB85C\uACE0 \uD639\uC740 \uB3C4\uC548\uD30C\uC77C\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694."));
                    case 12:
                        _$modifyDefaultModal({
                            show: true,
                            actionBtnActive: true,
                            actionBtnLabel: "\uADF8\uB300\uB85C \uC8FC\uBB38\uD558\uAE30",
                            cancelBtnLabel: "\uB2E4\uC2DC \uB2F4\uC73C\uB7EC \uAC00\uAE30",
                            bodyContent: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://file.caretbio.com/caretbio/7410e4e7344808f189a38ee7240ced29.png",
                                        alt: "\uC18C\uB7C9\uC778\uC1C4 \uC548\uB0B4 \uC774\uBBF8\uC9C0",
                                        style: {
                                            maxWidth: "294px",
                                            marginBottom: "10px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#253d4e",
                                            fontSize: "18px"
                                        },
                                        children: "\uC18C\uB7C9\uC778\uC1C4\uB294 1,000\uC7A5\uC774 \uAC00\uC7A5 \uC800\uB834\uD569\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#253d4e",
                                            fontSize: "18px"
                                        },
                                        children: "1,000\uC7A5 \uC778\uC1C4\uC2DC \uCD5C\uB300 78% \uD560\uC778\uC774 \uC801\uC6A9\uB429\uB2C8\uB2E4."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        style: {
                                            color: "#253d4e",
                                            fontSize: "15px",
                                            marginBottom: "20px"
                                        },
                                        children: "(100\uC7A5 \uB300\uBE44 / \uC7A5\uB2F9 \uAC00\uACA9 \uAE30\uC900)"
                                    })
                                ]
                            }),
                            onAction: _asyncToGenerator(runtime_default().mark(function _callee() {
                                var res, ref;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _$isLoading();
                                            _ctx.next = 3;
                                            return (0,smallPackaging/* smallPackagingAPI */.t)(body);
                                        case 3:
                                            res = _ctx.sent;
                                            if (res.Code === "0000") {
                                                queryClient.setQueryData([
                                                    queryKeys/* QUERY_KEYS.CUSTOMIZING.PRINT.CART */.U.CUSTOMIZING.PRINT.CART
                                                ], []);
                                                sessionStorage.setItem("printCart", JSON.stringify([]));
                                                _$isLoaded();
                                                router.push("/mypage/print");
                                            } else {
                                                ;
                                                _$isLoaded();
                                                (0,common_alert/* failAlert */.qh)(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uACAC\uC801 \uC694\uCCAD \uC2E4\uD328");
                                            }
                                            _$closeDefaultModal();
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }))
                        });
                        _$openDefaultModal();
                    case 14:
                    case "end":
                        return _ctx2.stop();
                }
            }, _callee2);
        }));
        return function confirmCustomizing() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (isOpen) {
            globalThis.onkeydown = function(e) {
                if (e.code === "Escape") {
                    setIsOpen(false);
                }
            };
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CartTableWrapper, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uD488\uBA85"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uC218\uB7C9"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uCD1D \uC218\uB7C9"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uD310\uB9E4\uAC00"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uC778\uC1C4\uBE44"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                            children: "\uC0AD\uC81C"
                                                        })
                                                    ]
                                                })
                                            }),
                                            printCartItems && printCartItems.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    printCartItems === null || printCartItems === void 0 ? void 0 : printCartItems.map(function(el, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    className: "info",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: "/products/".concat(el.ename, "/").concat(el.pcode, "/"),
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            style: {
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                gap: "10px"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                    src: el.main_image,
                                                                                    alt: el.pname
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    children: el.pname
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    style: {
                                                                        width: "15%"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "d-flex align-items-center w-100",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                                className: "form-control text-center me-2",
                                                                                type: "number",
                                                                                min: 1,
                                                                                max: 1000,
                                                                                value: el.cnt || 1,
                                                                                onChange: function(e) {
                                                                                    return handleCnt(e, el.pcode);
                                                                                }
                                                                            }),
                                                                            "\uAC1C"
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                                                    children: [
                                                                        (0,splicePrice/* priceComma */.a)(Number(el.quantity) * Number(el.cnt)),
                                                                        "\uAC1C"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: (0,splicePrice/* priceComma */.a)(Number(el.discount_price) * Number(el.cnt))
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    style: {
                                                                        whiteSpace: "nowrap"
                                                                    },
                                                                    children: "24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                        className: "btn btn-sm btn-danger",
                                                                        onClick: function() {
                                                                            return deleteBasketItem(el.pcode);
                                                                        },
                                                                        children: "\uC0AD\uC81C"
                                                                    })
                                                                })
                                                            ]
                                                        }, i);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            colSpan: 999,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                                                onClick: function() {
                                                                    return moveToList();
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi-rs-plus"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            colSpan: 999,
                                                            children: "\uB2F4\uAE34 \uC0C1\uD488\uC774 \uC5C6\uC2B5\uB2C8\uB2E4."
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                            colSpan: 999,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                                                onClick: function() {
                                                                    return moveToList();
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                    className: "fi-rs-plus"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                printCartItems && /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileCartWrapper, {
                                    children: [
                                        printCartItems === null || printCartItems === void 0 ? void 0 : printCartItems.map(function(el, i) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(CartProductsMobile, {
                                                children: [
                                                    (printCartItems === null || printCartItems === void 0 ? void 0 : printCartItems.length) <= 0 && "\uACAC\uC801\uC774 \uC5C6\uC2B5\uB2C8\uB2E4",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "custome-checkbox me-3",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                type: "checkbox",
                                                                id: "".concat(el.id),
                                                                className: "form-check-input",
                                                                value: el.id ? el.id : "",
                                                                onChange: selectItem(i, el),
                                                                checked: selectedItem[i]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                                className: "form-check-label d-flex",
                                                                htmlFor: "".concat(el.id),
                                                                style: {
                                                                    textTransform: "capitalize"
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductMobileImg, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                            src: el.main_image,
                                                            alt: "",
                                                            className: "mr-10"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductMobileInfo, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                children: el.pname
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "d-flex align-items-center",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            style: {
                                                                                width: "fit-content",
                                                                                whiteSpace: "nowrap"
                                                                            },
                                                                            className: "me-2",
                                                                            children: "\uC218\uB7C9 :"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                            className: "form-control w-100 text-center me-2",
                                                                            type: "number",
                                                                            min: 1,
                                                                            max: 1000,
                                                                            value: el.cnt || 1,
                                                                            onChange: function(e) {
                                                                                return handleCnt(e, el.pcode);
                                                                            },
                                                                            style: {
                                                                                height: "40px"
                                                                            }
                                                                        }),
                                                                        "\uAC1C"
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "\uBB36\uC74C\uC218\uB7C9 :",
                                                                    " ",
                                                                    (0,splicePrice/* priceComma */.a)(Number(el.quantity) * Number(el.cnt)),
                                                                    "\uAC1C"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "\uD310\uB9E4\uAC00 :",
                                                                    " ",
                                                                    (0,splicePrice/* priceComma */.a)(Number(el.discount_price) * Number(el.cnt)),
                                                                    "\uC6D0"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uC778\uC1C4\uBE44 : 24\uC2DC\uAC04 \uC774\uB0B4 \uACAC\uC801"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "btn_wrapper",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                    className: "btn btn-sm btn-danger ml-10 mt-5",
                                                                    onClick: function() {
                                                                        return deleteBasketItem(el.pcode);
                                                                    },
                                                                    children: "\uC0AD\uC81C"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i);
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon, {
                                            onClick: function() {
                                                return moveToList();
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fi-rs-plus"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoWrapper, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        children: [
                                                            "\uC8FC\uBB38\uC778 \uC815\uBCF4",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "input-option",
                                                                style: {
                                                                    color: "red"
                                                                },
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uC5C5\uCCB4\uBA85"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "\uC5C5\uCCB4\uBA85",
                                                            onChange: onChangeUserInputs("company"),
                                                            defaultValue: (userCompany === null || userCompany === void 0 ? void 0 : userCompany.name) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uB2F4\uB2F9\uC790"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "\uB2F4\uB2F9\uC790",
                                                            onChange: onChangeUserInputs("name"),
                                                            defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : (ref15 = userInfo.Member) === null || ref15 === void 0 ? void 0 : ref15.name) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uB2F4\uB2F9\uC790 \uC5F0\uB77D\uCC98"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "-\uB97C \uC81C\uC678\uD55C \uC22B\uC790\uB9CC",
                                                            onChange: onChangeUserInputs("phone"),
                                                            defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : (ref1 = userInfo.Member) === null || ref1 === void 0 ? void 0 : ref1.phone) || "",
                                                            maxLength: 13
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uB2F4\uB2F9\uC790 \uC774\uBA54\uC77C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            type: "text",
                                                            placeholder: "\uC774\uBA54\uC77C",
                                                            onChange: onChangeUserInputs("email"),
                                                            defaultValue: (userInfo === null || userInfo === void 0 ? void 0 : (ref2 = userInfo.Member) === null || ref2 === void 0 ? void 0 : ref2.email) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title mt-25",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                        children: [
                                                            "\uBC30\uC1A1\uC9C0 \uC815\uBCF4",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "input-option",
                                                                style: {
                                                                    color: "red"
                                                                },
                                                                children: "(\uD544\uC218)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(AddressSearch, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                            children: "\uC8FC\uC18C"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormBasicBtn, {
                                                                    type: "button",
                                                                    onClick: onClickHandleModal,
                                                                    children: "\uC8FC\uC18C\uAC80\uC0C9"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                                    disabled: true,
                                                                    value: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.addressCode) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.zipcode) || "",
                                                                    readOnly: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            disabled: true,
                                                            address: true,
                                                            readOnly: true,
                                                            value: pickAddress || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.doro_addr) || ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {}),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            placeholder: "\uC0C1\uC138\uC8FC\uC18C \uC785\uB825",
                                                            address: true,
                                                            value: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.detail_addr) || (userCompany === null || userCompany === void 0 ? void 0 : userCompany.detail_addr) || "",
                                                            onChange: onChangeUserInputs("detail_addr")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title mt-25",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "\uBC30\uC1A1 \uBA54\uC138\uC9C0"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                    placeholder: "\uBC30\uC1A1 \uC2DC \uC694\uCCAD\uD560 \uB0B4\uC6A9\uC744 \uC791\uC131\uD574\uC8FC\uC138\uC694.",
                                                    onChange: onChangeUserInputs("message")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoBox, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                        children: "\uD3EC\uC7A5 \uC0C1\uD488 \uC815\uBCF4"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeSpan, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: "\uD3EC\uC7A5\uD558\uC2DC\uB294 \uC0C1\uD488 \uC815\uBCF4\uB97C \uBAA8\uB450 \uC785\uB825\uD574\uC8FC\uC138\uC694."
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "example",
                                                                    children: "\uC608\uC2DC) 4kg / \uD654\uC7A5\uD488"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicInput, {
                                                            placeholder: "\uC0C1\uD488 \uC815\uBCF4 \uC785\uB825",
                                                            full: true,
                                                            onChange: onChangeUserInputs("productInfo")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeSpan, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    children: [
                                                                        "\uD30C\uC77C \uC5C5\uB85C\uB4DC",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "input-option",
                                                                            style: {
                                                                                color: "red"
                                                                            },
                                                                            children: "(\uD544\uC218)"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        href: "https://file.caretbio.com/caretbio/Caretstore_Cutting_Guide_2506.zip",
                                                                        target: "__blank",
                                                                        className: "btn btn-small w-fit",
                                                                        children: "\uCE7C\uC120 \uB2E4\uC6B4\uB85C\uB4DC"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FileUploadWrapper, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomFileInput/* default */.Z, {
                                                                handleFiles: onChangeFiles,
                                                                ment: ((userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) === "TYPE0" || !(userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn)) && "\uCE7C\uC120 \uB3C4\uC548\uC744 \uC5C5\uB85C\uB4DC \uD574\uC8FC\uC138\uC694." || (userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) === "TYPE1" && "\uB85C\uACE0\uB97C \uC5C5\uB85C\uB4DC \uD574\uC8FC\uC138\uC694." || (userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) === "TYPE2" && ""
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "mt-10",
                                                            children: "* \uB85C\uACE0\uD30C\uC77C \uB610\uB294 \uB85C\uACE0\uAC00 \uBC30\uCE58\uB41C \uCE7C\uC120\uB3C4\uC548\uC744 \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694 (ai \uD30C\uC77C)"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "* \uB85C\uACE0\uAC00 \uC900\uBE44\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC740 \uACBD\uC6B0\uC5D0\uB294 \uAD00\uB828 \uC774\uBBF8\uC9C0\uB97C \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694 (\uD30C\uC77C \uD615\uC2DD \uBB34\uAD00)"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title mt-25",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "\uC120\uD0DD \uC0AC\uD56D"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputRow, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormInputBasicSpan, {
                                                                    large: true,
                                                                    children: "\uB514\uC790\uC778 \uC791\uC5C5"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputBasicSelect, {
                                                                    address: true,
                                                                    value: (userInputs === null || userInputs === void 0 ? void 0 : userInputs.editYn) || "TYPE0",
                                                                    onChange: onChangeUserInputs("editYn"),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "TYPE0",
                                                                            children: "\uC120\uD0DD \uC548\uD568"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "TYPE1",
                                                                            children: "\uB3C4\uC548 \uCE7C\uC120\uBC30\uCE58"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                            value: "TYPE2",
                                                                            children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4(\uBCC4\uB3C4 \uBE44\uC6A9 \uC0C1\uB2F4)"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "* \uB85C\uACE0\uD30C\uC77C\uC774 \uC788\uC9C0\uB9CC \uC77C\uB7EC\uC2A4\uD2B8 \uC791\uC5C5\uC774 \uC5B4\uB824\uC6B0\uC2E0 \uCE7C\uC120\uB3C4\uC548 \uBC30\uCE58\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "* \uB85C\uACE0\uD30C\uC77C\uC774 \uC5C6\uB294 \uACBD\uC6B0 \uB514\uC790\uC778 \uC11C\uBE44\uC2A4\uB97C \uC120\uD0DD\uD574\uC8FC\uC138\uC694."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "d-flex justify-content-end mt-5",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "/customizing/design-service",
                                                                target: "__blank",
                                                                className: "btn btn-small w-fit",
                                                                children: "\uB514\uC790\uC778 \uC11C\uBE44\uC2A4 \uBCF4\uB7EC\uAC00\uAE30"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormInputLargeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "title",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                children: "\uC694\uCCAD \uC0AC\uD56D "
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                                            placeholder: "\uACAC\uC801\uC2DC \uC694\uCCAD\uD560 \uB0B4\uC6A9\uC744 \uC791\uC131\uD574\uC8FC\uC138\uC694.",
                                                            onChange: onChangeUserInputs("content")
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CartBtnWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        className: "btn btn-md",
                                        onClick: confirmCustomizing,
                                        children: [
                                            router.query.type === "direct" ? "" : "\uC120\uD0DD",
                                            " \uACAC\uC801 \uC694\uCCAD"
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(postcode/* default */.Z, {
                onClickHandleModal: onClickHandleModal,
                onCompletePostCode: onCompletePostCode
            }),
            pickAddress && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    display: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Maptainer/* default */.Z, {
                    userInputs: userInputs,
                    setUserInputs: setUserInputs,
                    address: pickAddress
                })
            })
        ]
    });
};
var mapDispatchToProps = {
    openConfirmModal: action_confirm/* openConfirmModal */._5,
    modifyConfirmModal: action_confirm/* modifyConfirmModal */.sR,
    closeConfirmModal: action_confirm/* closeConfirmModal */.d6,
    isLoaded: loading/* isLoaded */.k,
    isLoading: loading/* isLoading */.h,
    closeDefaultModal: defaultModal/* closeDefaultModal */._i,
    modifyDefaultModal: defaultModal/* modifyDefaultModal */.kj,
    openDefaultModal: defaultModal/* openDefaultModal */.Rh
};
/* harmony default export */ var printCart_PrintCart = ((0,es/* connect */.$j)(null, mapDispatchToProps)(PrintCart));


/***/ }),

/***/ 48071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ PrintTab; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32252);
/* harmony import */ var _hook_customizing_print_useTabStickyHandler__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15634);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _hook_customizing_print_usePrintFaqQuery__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39117);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _common_pageRouter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92534);
/* harmony import */ var _hook_customizing_print_usePrintProductListQuery__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44756);








var ESTIMATE_TAB_TITLE = "\uACAC\uC801\uC694\uCCAD";
var ROOT_TITLE = "\uC18C\uB7C9\uC778\uC1C4";
var PrintTab = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var tabHeaderRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var isSticky = (0,_hook_customizing_print_useTabStickyHandler__WEBPACK_IMPORTED_MODULE_2__/* .useTabStickyHandler */ .h)(tabHeaderRef).isSticky;
    // FAQ (로딩이 끝난 뒤에만 조회하도록 isReady 전달)
    var ref2 = (0,_hook_customizing_print_usePrintFaqQuery__WEBPACK_IMPORTED_MODULE_4__/* .usePrintFaqQuery */ .p)(router.isReady), faqList = ref2.data;
    // 장바구니 아이템 구독 (react-query)
    var ref1 = (0,_hook_customizing_print_usePrintProductListQuery__WEBPACK_IMPORTED_MODULE_7__/* .usePrintCartItemsQuery */ .J)(), tmp = ref1.data, printCartItems = tmp === void 0 ? [] : tmp;
    // 배지용 카운트 (원하는 기준으로 사용)
    var cartItemCount = printCartItems.length; // 서로 다른 상품 개수
    // const cartQtySum = printCartItems.reduce((acc, cur) => acc + (Number(cur.cnt) || 0), 0); // 총 수량 합계
    // "소량인쇄" 하위 탭
    var tabRouter = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        var ref;
        return ((ref = _common_pageRouter__WEBPACK_IMPORTED_MODULE_6__/* .PageRouter.find */ .L.find(function(item) {
            return item.title === ROOT_TITLE;
        })) === null || ref === void 0 ? void 0 : ref.sub) || [];
    }, []);
    // FAQ 없으면 FAQ 탭 제거
    var tabs = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        if (!faqList) return tabRouter;
        return faqList.length === 0 ? tabRouter.filter(function(tab) {
            return tab.title !== "\uC18C\uB7C9\uC778\uC1C4 FAQ";
        }) : tabRouter;
    }, [
        faqList,
        tabRouter
    ]);
    var onChangeMainTab = function(tab) {
        if ((tab === null || tab === void 0 ? void 0 : tab.url) && tab.url !== router.pathname) {
            router.push(tab.url);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .TabContainer */ .Xl, {
        ref: tabHeaderRef,
        isSticky: isSticky,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .TabHeader */ .GK, {
            children: tabs.map(function(tab) {
                var isActive = router.pathname === (tab === null || tab === void 0 ? void 0 : tab.url);
                var isEstimateTab = (tab === null || tab === void 0 ? void 0 : tab.title) === ESTIMATE_TAB_TITLE;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_customizing_print_Print_styles__WEBPACK_IMPORTED_MODULE_1__/* .TabItem */ .E2, {
                    active: isActive,
                    onClick: function() {
                        return onChangeMainTab(tab);
                    },
                    style: {
                        position: "relative"
                    },
                    children: [
                        tab === null || tab === void 0 ? void 0 : tab.title,
                        isEstimateTab && cartItemCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                marginLeft: 8,
                                display: "inline-block",
                                minWidth: 18,
                                padding: "0 6px",
                                height: 18,
                                lineHeight: "18px",
                                borderRadius: 9,
                                fontSize: 12,
                                textAlign: "center",
                                background: "#ef4444",
                                color: "#fff",
                                verticalAlign: "middle"
                            },
                            children: cartItemCount
                        })
                    ]
                }, (tab === null || tab === void 0 ? void 0 : tab.url) || (tab === null || tab === void 0 ? void 0 : tab.title));
            })
        })
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (PrintTab)));


/***/ }),

/***/ 590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ KakaoMap; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


function KakaoMap(props) {
    var address = String(props.address);
    var a = props === null || props === void 0 ? void 0 : props.a;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var script = document.createElement("script");
        script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=7ba8898b0f6ed44fb3875c4acd1ec57d&autoload=false&libraries=services ";
        document.head.appendChild(script);
        script.onload = function() {
            window.kakao.maps.load(function() {
                var container = document.getElementById("map"); // 지도를 담을 영역의 DOM 레퍼런스
                var options = {
                    // 지도를 생성할 때 필요한 기본 옵션
                    center: new window.kakao.maps.LatLng(37.544347981356054, 126.958562062053735),
                    level: 3
                };
                var map = new window.kakao.maps.Map(container, options); // 지도 생성 및 객체 리턴
                // const imageSize = new window.kakao.maps.Size(60, 60); // 마커이미지의 크기입니다
                // const imageOption = { offset: new window.kakao.maps.Point(27, 69) }; // 마커이미지의 옵션입니다. 마커의 좌표와 일치시킬 이미지 안에서의 좌표를 설정합니다.
                // const markerImage = new window.kakao.maps.MarkerImage(
                //   imageSize,
                //   imageOption
                // );
                // 주소-좌표 변환 객체를 생성합니다
                var geocoder = new window.kakao.maps.services.Geocoder();
                // 주소로 좌표를 검색합니다
                geocoder.addressSearch(address, function(result, status) {
                    var ref, ref1;
                    props === null || props === void 0 ? void 0 : props.setUserInputs(_objectSpread({}, props === null || props === void 0 ? void 0 : props.userInputs, {
                        addressGps: {
                            mapx: (ref = result[0]) === null || ref === void 0 ? void 0 : ref.x,
                            mapy: (ref1 = result[0]) === null || ref1 === void 0 ? void 0 : ref1.y
                        }
                    }));
                    // 정상적으로 검색이 완료됐으면
                    if (status === window.kakao.maps.services.Status.OK) {
                        var coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                        if (props.setGps) props.setGps(coords);
                        // 결과값으로 받은 위치를 마커로 표시합니다
                        var marker = new window.kakao.maps.Marker({
                            map: map,
                            position: coords
                        });
                        // 인포윈도우로 장소에 대한 설명을 표시합니다
                        var info = new window.kakao.maps.InfoWindow({
                            content: '<div style="width:210px;text-align:center;padding:5px 0;">'.concat(address, "</div>")
                        });
                        info.open(map, marker);
                        // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
                        map.panTo(coords);
                    //   // 지도를 클릭하면 마지막 파라미터로 넘어온 함수를 호출합니다
                    //   window.kakao.maps.event.addListener(
                    //     map,
                    //     "click",
                    //     function (mouseEvent: any) {
                    //       // 클릭한 위도, 경도 정보를 가져옵니다
                    //       const latlng = mouseEvent.latLng;
                    //       // 마커 위치를 클릭한 위치로 옮깁니다
                    //       marker.setPosition(latlng);
                    //     }
                    //   );
                    }
                });
            });
        };
    }, [
        address,
        a
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "map",
            style: {
                width: "100%",
                height: "100%"
            }
        })
    });
};


/***/ }),

/***/ 39117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ usePrintFaqQuery; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51586);
/* harmony import */ var _api_boards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67623);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintFaqQuery = function() {
    var enabledCondition = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.CUSTOMIZING.PRINT.FAQ */ .U.CUSTOMIZING.PRINT.FAQ,
        queryFn: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "List",
                            boardName: "sfaq"
                        };
                        _ctx.next = 3;
                        return (0,_api_boards__WEBPACK_IMPORTED_MODULE_2__/* .fetchBoards */ .P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code === "0000" || res.code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", res.data.data);
                    case 8:
                        return _ctx.abrupt("return", []);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        retry: 1,
        enabled: enabledCondition,
        cacheTime: 1000 * 60 * 30
    });
};


/***/ }),

/***/ 44756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ usePrintCartItemsQuery; },
/* harmony export */   "u": function() { return /* binding */ usePrintProductListQuery; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51586);
/* harmony import */ var _api_smallPackaging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85134);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var usePrintProductListQuery = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.CUSTOMIZING.PRINT.PRODUCTS */ .U.CUSTOMIZING.PRINT.PRODUCTS
        ],
        queryFn: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, body, res, ref1;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        body = {
                            modes: "ProductsListSet"
                        };
                        _ctx.next = 4;
                        return (0,_api_smallPackaging__WEBPACK_IMPORTED_MODULE_2__/* .smallPackagingAPI */ .t)(body);
                    case 4:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", (ref1 = res.Data) === null || ref1 === void 0 ? void 0 : ref1.rows.data);
                    case 8:
                        throw new Error(((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Msg) || "\uC0C1\uD488 \uBAA9\uB85D\uC744 \uBD88\uB7EC\uC624\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.");
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
};
var usePrintCartItemsQuery = function() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.CUSTOMIZING.PRINT.CART */ .U.CUSTOMIZING.PRINT.CART
        ],
        queryFn: function() {
            var items = JSON.parse(sessionStorage.getItem("printCart") || "[]");
            return items;
        },
        enabled: "object" !== "undefined"
    });
};


/***/ }),

/***/ 90651:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=_interopRequireWildcard(__webpack_require__(67294)),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["scriptUrl","className","style","defaultQuery","autoClose","errorMessage","onComplete","onClose","onResize","onSearch"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function _classCallCheck(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}function _defineProperties(a,b){for(var c,d=0;d<b.length;d++)c=b[d],c.enumerable=c.enumerable||!1,c.configurable=!0,"value"in c&&(c.writable=!0),Object.defineProperty(a,c.key,c)}function _createClass(a,b,c){return b&&_defineProperties(a.prototype,b),c&&_defineProperties(a,c),a}function _inherits(a,b){if("function"!=typeof b&&null!==b)throw new TypeError("Super expression must either be null or a function");a.prototype=Object.create(b&&b.prototype,{constructor:{value:a,writable:!0,configurable:!0}}),b&&_setPrototypeOf(a,b)}function _setPrototypeOf(a,b){return _setPrototypeOf=Object.setPrototypeOf||function(a,b){return a.__proto__=b,a},_setPrototypeOf(a,b)}function _createSuper(a){var b=_isNativeReflectConstruct();return function(){var c,d=_getPrototypeOf(a);if(b){var e=_getPrototypeOf(this).constructor;c=Reflect.construct(d,arguments,e)}else c=d.apply(this,arguments);return _possibleConstructorReturn(this,c)}}function _possibleConstructorReturn(a,b){return b&&("object"===_typeof(b)||"function"==typeof b)?b:_assertThisInitialized(a)}function _assertThisInitialized(a){if(void 0===a)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return a}function _isNativeReflectConstruct(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(a){return!1}}function _getPrototypeOf(a){return _getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(a){return a.__proto__||Object.getPrototypeOf(a)},_getPrototypeOf(a)}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}var defaultErrorMessage=/*#__PURE__*/_react.default.createElement("p",null,"\uD604\uC7AC Daum \uC6B0\uD3B8\uBC88\uD638 \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574\uC8FC\uC138\uC694."),defaultStyle={width:"100%",height:400},defaultProps={scriptUrl:_loadPostcode.postcodeScriptUrl,errorMessage:defaultErrorMessage,autoClose:!0},DaumPostcodeEmbed=/*#__PURE__*/function(a){function b(){var a;_classCallCheck(this,b);for(var d=arguments.length,e=Array(d),f=0;f<d;f++)e[f]=arguments[f];return a=c.call.apply(c,[this].concat(e)),_defineProperty(_assertThisInitialized(a),"mounted",!1),_defineProperty(_assertThisInitialized(a),"wrap",/*#__PURE__*/(0,_react.createRef)()),_defineProperty(_assertThisInitialized(a),"state",{hasError:!1}),_defineProperty(_assertThisInitialized(a),"initiate",function(b){if(a.wrap.current){var c=a.props,d=c.scriptUrl,e=c.className,f=c.style,g=c.defaultQuery,h=c.autoClose,i=c.errorMessage,j=c.onComplete,k=c.onClose,l=c.onResize,m=c.onSearch,n=_objectWithoutProperties(c,_excluded),o=new b(_objectSpread(_objectSpread({},n),{},{oncomplete:function oncomplete(b){j&&j(b),h&&a.wrap.current&&a.wrap.current.remove()},onsearch:m,onresize:l,onclose:k,width:"100%",height:"100%"}));o.embed(a.wrap.current,{q:g,autoClose:h})}}),_defineProperty(_assertThisInitialized(a),"onError",function(b){console.error(b),a.setState({hasError:!0})}),a}_inherits(b,a);var c=_createSuper(b);return _createClass(b,[{key:"componentDidMount",value:function componentDidMount(){var a=this.initiate,b=this.onError,c=this.props.scriptUrl;c&&(this.mounted||((0,_loadPostcode.default)(c).then(a).catch(b),this.mounted=!0))}},{key:"render",value:function render(){var a=this.props,b=a.className,c=a.style,d=a.errorMessage,e=this.state.hasError;return/*#__PURE__*/_react.default.createElement("div",{ref:this.wrap,className:b,style:_objectSpread(_objectSpread({},defaultStyle),c)},e&&d)}}]),b}(_react.Component);_defineProperty(DaumPostcodeEmbed,"defaultProps",defaultProps);var _default=DaumPostcodeEmbed;exports["default"]=_default;

/***/ }),

/***/ 60007:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
__webpack_unused_export__ = ({value:!0}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _DaumPostcodeEmbed.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _useDaumPostcodePopup.default}}),__webpack_unused_export__ = ({enumerable:!0,get:function get(){return _loadPostcode.default}}),exports.ZP=void 0;var _DaumPostcodeEmbed=_interopRequireDefault(__webpack_require__(90651)),_useDaumPostcodePopup=_interopRequireDefault(__webpack_require__(339)),_loadPostcode=_interopRequireDefault(__webpack_require__(52171));function _interopRequireDefault(a){return a&&a.__esModule?a:{default:a}}var _default=_DaumPostcodeEmbed.default;exports.ZP=_default;

/***/ }),

/***/ 52171:
/***/ (function(__unused_webpack_module, exports) {

Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=exports.postcodeScriptUrl=void 0;var postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";exports.postcodeScriptUrl="https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";var loadPostcode=function(){var a=null;return function(){var b=0<arguments.length&&void 0!==arguments[0]?arguments[0]:postcodeScriptUrl;return a?a:(a=new Promise(function(a,c){var d=document.createElement("script");d.src=b,d.onload=function(){var b,d;return null!==(b=window)&&void 0!==b&&null!==(d=b.daum)&&void 0!==d&&d.Postcode?a(window.daum.Postcode):void c(new Error("Script is loaded successfully, but cannot find Postcode module. Check your scriptURL property."))},d.onerror=function(a){return c(a)},d.id="daum_postcode_script",document.body.appendChild(d)}),a)}}(),_default=loadPostcode;exports["default"]=_default;

/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

function _typeof(a){"@babel/helpers - typeof";return _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(a){return typeof a}:function(a){return a&&"function"==typeof Symbol&&a.constructor===Symbol&&a!==Symbol.prototype?"symbol":typeof a},_typeof(a)}Object.defineProperty(exports, "__esModule", ({value:!0})),exports["default"]=void 0;var _react=__webpack_require__(67294),_loadPostcode=_interopRequireWildcard(__webpack_require__(52171)),_excluded=["defaultQuery","left","top","popupKey","popupTitle","autoClose","onComplete","onResize","onClose","onSearch","onError"];function _getRequireWildcardCache(a){if("function"!=typeof WeakMap)return null;var b=new WeakMap,c=new WeakMap;return(_getRequireWildcardCache=function(a){return a?c:b})(a)}function _interopRequireWildcard(a,b){if(!b&&a&&a.__esModule)return a;if(null===a||"object"!==_typeof(a)&&"function"!=typeof a)return{default:a};var c=_getRequireWildcardCache(b);if(c&&c.has(a))return c.get(a);var d={},e=Object.defineProperty&&Object.getOwnPropertyDescriptor;for(var f in a)if("default"!=f&&Object.prototype.hasOwnProperty.call(a,f)){var g=e?Object.getOwnPropertyDescriptor(a,f):null;g&&(g.get||g.set)?Object.defineProperty(d,f,g):d[f]=a[f]}return d.default=a,c&&c.set(a,d),d}function ownKeys(a,b){var c=Object.keys(a);if(Object.getOwnPropertySymbols){var d=Object.getOwnPropertySymbols(a);b&&(d=d.filter(function(b){return Object.getOwnPropertyDescriptor(a,b).enumerable})),c.push.apply(c,d)}return c}function _objectSpread(a){for(var b,c=1;c<arguments.length;c++)b=null==arguments[c]?{}:arguments[c],c%2?ownKeys(Object(b),!0).forEach(function(c){_defineProperty(a,c,b[c])}):Object.getOwnPropertyDescriptors?Object.defineProperties(a,Object.getOwnPropertyDescriptors(b)):ownKeys(Object(b)).forEach(function(c){Object.defineProperty(a,c,Object.getOwnPropertyDescriptor(b,c))});return a}function _defineProperty(a,b,c){return b in a?Object.defineProperty(a,b,{value:c,enumerable:!0,configurable:!0,writable:!0}):a[b]=c,a}function _objectWithoutProperties(a,b){if(null==a)return{};var c,d,e=_objectWithoutPropertiesLoose(a,b);if(Object.getOwnPropertySymbols){var f=Object.getOwnPropertySymbols(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||Object.prototype.propertyIsEnumerable.call(a,c)&&(e[c]=a[c])}return e}function _objectWithoutPropertiesLoose(a,b){if(null==a)return{};var c,d,e={},f=Object.keys(a);for(d=0;d<f.length;d++)c=f[d],0<=b.indexOf(c)||(e[c]=a[c]);return e}function useDaumPostcodePopup(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:_loadPostcode.postcodeScriptUrl;(0,_react.useEffect)(function(){(0,_loadPostcode.default)(a)},[a]);var b=(0,_react.useCallback)(function(b){var c=_objectSpread({},b),d=c.defaultQuery,e=c.left,f=c.top,g=c.popupKey,h=c.popupTitle,i=c.autoClose,j=c.onComplete,k=c.onResize,l=c.onClose,m=c.onSearch,n=c.onError,o=_objectWithoutProperties(c,_excluded);return(0,_loadPostcode.default)(a).then(function(a){var b=new a(_objectSpread(_objectSpread({},o),{},{oncomplete:j,onsearch:m,onresize:k,onclose:l}));b.open({q:d,left:e,top:f,popupTitle:h,popupKey:g,autoClose:i})}).catch(n)},[a]);return b}var _default=useDaumPostcodePopup;exports["default"]=_default;

/***/ })

}]);